export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/3346696aa3bfc7ad40e0ac1560f784e6.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B3A6E]/90 via-[#0B3A6E]/85 to-[#0B3A6E]/90"></div>
      
      {/* Marca d'água da logo */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <img 
          src="https://static.readdy.ai/image/d9341b18b0ec25b73a2a0083444a8be7/cd3781bfb9ae66323e1c7ba0d9d5685e.png" 
          alt="" 
          className="w-[600px] h-auto opacity-5"
        />
      </div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" style={{ textShadow: '2px 2px 8px rgba(0, 0, 0, 0.8)' }}>
          NTC Tecnologia — Data Center,<br />Backup e Cloud em Manaus
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-100 mb-12 max-w-4xl mx-auto leading-relaxed">
          28 anos de experiência, preço fixo em reais e suporte humano de verdade.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="https://wa.me/5592991426889" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-[#F5A623] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#E09515] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center gap-2"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Falar no WhatsApp
          </a>
          <button 
            onClick={() => document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-[#0B3A6E] px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Solicitar Proposta
          </button>
        </div>
        
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#F5A623] mb-2">28</div>
            <div className="text-white text-sm">Anos de Experiência</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#F5A623] mb-2">100%</div>
            <div className="text-white text-sm">Infraestrutura Própria</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#F5A623] mb-2">24/7</div>
            <div className="text-white text-sm">Suporte Disponível</div>
          </div>
        </div>
      </div>
    </section>
  );
}